export const DAILY_CHECKIN_REQUIRED_KEYS = [
  "DC_EFFORT",
  "DC_PHYSICAL",
  "DC_PSYCHOLOGICAL",
  "DC_WORK",
] as const;

export type DailyCheckinKey = (typeof DAILY_CHECKIN_REQUIRED_KEYS)[number];

export const DAILY_CHECKIN_LABELS: Record<DailyCheckinKey, string> = {
  DC_EFFORT: "Effort & Attitude",
  DC_WORK: "Work & Relationships",
  DC_PHYSICAL: "Physical",
  DC_PSYCHOLOGICAL: "Psychological",
};
